import { formatAmount, moneyLocale } from "./money.mjs";

// Where the language of the signed in user comes from (the store registers it: this module does not import the store,
// which imports it). Read at every call, so a list rendered from the store's state follows a language change.
let languageSource = () => null;

export function setMoneyLanguageSource(source) {
  languageSource = source;
}

// An amount with its currency as the lists show it (HUF without fractions), in the user's language; `signed` puts a + in
// front of a gain.
export default function formatMoney(amount, currency, signed = false) {
  return formatAmount(amount, currency, moneyLocale(languageSource()), signed);
}
